import axios from 'axios';
import qs from 'qs';
import { ServiceResponse } from '@/OptimusRoutes/interfaces';
import { FETCH_SIMS, FETCH_SIMS_COUNT } from './actionTypes';
import {
	AddSimProps,
	DeleteSimsProps,
	EditSimProps,
	GetSimsProps,
	SimsResponse,
	UpdateSimStatusProps,
} from './sim.types';

interface ISimService {
	getSims(props: GetSimsProps): Promise<ServiceResponse<SimsResponse>>;
	editSim(props: EditSimProps): Promise<ServiceResponse<SimsResponse>>;
	deleteSims(props: DeleteSimsProps): Promise<ServiceResponse<SimsResponse>>;
	addSim(props: AddSimProps): Promise<ServiceResponse<SimsResponse>>;
	updateSimStatus(props: UpdateSimStatusProps): Promise<ServiceResponse<SimsResponse>>;
	simExist(line: string): Promise<boolean>;
}

class Service implements ISimService {
	//TODO: remove dispatch from here
	async getSims({
		search = '',
		page = 1,
		pageSize = 15,
		dispatch,
		includeStatus,
	}: GetSimsProps): Promise<ServiceResponse<SimsResponse>> {
		if (search !== '') search = '%' + search + '%';
		const request = { skip: (page - 1) * pageSize, take: pageSize, search, includeStatus };
		const { data: response } = await axios.get<ServiceResponse<SimsResponse>>(`/v2/sims?${qs.stringify(request)}`);

		if (response?.success) {
			const { data, count } = response.success;
			dispatch({ type: FETCH_SIMS, payload: data });
			dispatch({ type: FETCH_SIMS_COUNT, count });
		}
		return response;
	}

	async editSim({ id, line, serial, carrierId }: EditSimProps) {
		const data = { line, serial, carrierId };
		const { data: response } = await axios.patch<ServiceResponse<SimsResponse>>(`/v2/sims/${id}`, data);
		return response;
	}

	async deleteSims({ ids }: DeleteSimsProps) {
		const options = { data: { ids } };
		const { data } = await axios.delete<ServiceResponse<SimsResponse>>(`/v2/sims`, options);
		return data;
	}

	async addSim({ line, serial, carrierId }: AddSimProps) {
		const data = { line, serial, carrierId: +carrierId };
		const { data: response } = await axios.post<ServiceResponse<SimsResponse>>(`/v2/sims`, data);
		return response;
	}

	async updateSimStatus({ line, status }: UpdateSimStatusProps) {
		const options = {
			line,
			status,
		};
		const { data } = await axios.patch<ServiceResponse<SimsResponse>>(`/v2/sims/${line}/status`, options);
		return data;
	}

	async simExist(line: string): Promise<boolean> {
		const { data } = await axios.get<ServiceResponse<boolean>>(`/v2/sims/exists?line=${encodeURIComponent(line)}`);

		if (data?.error) {
			return false;
		}
		return !!data?.success;
	}
}

const SimService = new Service();

export default SimService;
